// extracted by mini-css-extract-plugin
export default {"joinCotainer":"joinByLink_joinCotainer__PA2Dk","offcameraContainer":"joinByLink_offcameraContainer__XtkkU","otherOptionMicrophone":"joinByLink_otherOptionMicrophone__YLNaj"};